import { IconComponent } from './types';

const CluBoundaryIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      d="M6.17.5h5.33v5h-3v6h-8V4.83L6.17.5ZM2.5 6.5l2 2.5m0 0 2-2.5M4.5 9V4.5"
    />
  </svg>
);
export default CluBoundaryIcon;
